export const userRoles = {
  ADMIN: 'Admin',
  Funder: 'Funder',
  PROJECT_MANAGER: 'Project Manager',
  FINANCE: 'Finance',
  CONSULTANT: 'Consultant',
  HR: 'HR',
  // External partner (e.g. UNAIDS): signs in to work on data files for one product only.
  PARTNER: 'Partner'
}

export const rolePermissions = {
  [userRoles.ADMIN]: {
    canManageUsers: true,
    canManageProjects: true,
    canApproveFunding: true,
    canViewFinances: true,
    canManageSystem: true,
    canViewReports: true,
    dashboardAccess: 'admin'
  },
  [userRoles.Funder]: {
    canManageUsers: false,
    canManageProjects: false,
    canApproveFunding: true,
    canViewFinances: true,
    canManageSystem: false,
    canViewReports: true,
    dashboardAccess: 'funder'
  },
  [userRoles.PROJECT_MANAGER]: {
    canManageUsers: false,
    canManageProjects: true,
    canApproveFunding: false,
    canViewFinances: true,
    canManageSystem: false,
    canViewReports: true,
    dashboardAccess: 'project-manager'
  },
  [userRoles.FINANCE]: {
    canManageUsers: false,
    canManageProjects: false,
    canApproveFunding: false,
    canViewFinances: true,
    canManageSystem: false,
    canViewReports: true,
    dashboardAccess: 'finance'
  },
  [userRoles.CONSULTANT]: {
    canManageUsers: false,
    canManageProjects: false,
    canApproveFunding: false,
    canViewFinances: false,
    canManageSystem: false,
    canViewReports: false,
    dashboardAccess: 'consultant'
  },
  [userRoles.HR]: {
    canManageUsers: false,
    canManageProjects: false,
    canApproveFunding: false,
    canViewFinances: false,
    canManageSystem: false,
    canViewReports: true,
    dashboardAccess: 'hr'
  },
  // An external partner can do nothing inside ProTrack itself. Everything they may touch is
  // granted per-product on the platform, so every flag here stays false on purpose.
  [userRoles.PARTNER]: {
    canManageUsers: false,
    canManageProjects: false,
    canApproveFunding: false,
    canViewFinances: false,
    canManageSystem: false,
    canViewReports: false,
    dashboardAccess: 'partner'
  }
}

export const mockUsers = [
  {
    id: 1,
    name: 'Bharat Admin',
    email: 'devops.internal@3pillarsdata.com',
    role: userRoles.ADMIN,
    status: 'Active',
    joinDate: '2024-01-01',
    avatar: 'BA',
    department: 'Administration'
  },
  {
    id: 2,
    name: 'Nandu Funder',
    email: 'abhishekhiremath215@gmail.com',
    role: userRoles.Funder,
    status: 'Active',
    joinDate: '2024-01-15',
    avatar: 'NF',
    department: 'Investment',
    fundingLimit: 2000000,
    approvedFunding: 1250000,
    availableFunds: 750000
  },
  {
    id: 3,
    name: 'Maha Project Manager',
    email: 'dhira6j@gmail.com',
    role: userRoles.PROJECT_MANAGER,
    status: 'Active',
    joinDate: '2024-02-01',
    avatar: 'MH',
    department: 'Management',
    projectsManaged: 8,
    currentProjects: 3,
    completedProjects: 5
  },
  {
    id: 4,
    name: 'Dhiru Finance',
    email: 'dhiraj@3pillarsdata.com',
    role: userRoles.FINANCE,
    status: 'Active',
    joinDate: '2024-01-20',
    avatar: 'DF',
    department: 'Finance',
    budgetAccessLevel: 'full'
  },
  {
    id: 5,
    name: 'Abhi Consultant',
    email: 'abhishek@3pillarsdata.com',
    role: userRoles.CONSULTANT,
    status: 'Active',
    joinDate: '2024-02-10',
    avatar: 'AH',
    department: 'Advisory',
    specialization: 'AI Strategy',
    hourlyRate: 200,
    contractType: 'External'
  }
]

export const mockProjects = [
  {
    id: 1,
    name: 'E-commerce Platform Development',
    description: 'Full-stack e-commerce platform with payment integration and mobile responsive design',
    status: 'In Progress',
    progress: 65,
    startDate: '2024-01-15',
    endDate: '2024-06-30',
    totalBudget: 450000,
    approvedBudget: 450000,
    spentBudget: 292500,
    remainingBudget: 157500,
    projectManager: 'Maha Project Manager',
    projectManagerId: 3,
    funder: 'Nandu Funder',
    funderId: 2,
    consultant: 'Abhi Consultant',
    consultantId: 5,
    priority: 'High',
    fundingStatus: 'Approved',
    nextMilestone: 'Payment Gateway Integration',
    riskLevel: 'Medium',
    category: 'Technology'
  },
  {
    id: 2,
    name: 'Mobile App Development',
    description: 'Cross-platform mobile application for customer engagement and loyalty program',
    status: 'Pending Approval',
    progress: 15,
    startDate: '2024-03-01',
    endDate: '2024-09-15',
    totalBudget: 320000,
    approvedBudget: 0,
    spentBudget: 48000,
    remainingBudget: 272000,
    projectManager: 'Maha Project Manager',
    projectManagerId: 3,
    funder: 'Nandu Funder',
    funderId: 2,
    consultant: 'Abhi Consultant',
    consultantId: 5,
    priority: 'Medium',
    fundingStatus: 'Pending',
    nextMilestone: 'Funding Approval Required',
    riskLevel: 'High',
    category: 'Mobile Technology'
  }
]

export const mockFundingRequests = [
  {
    id: 1,
    projectId: 2,
    projectName: 'Mobile App Development',
    requestedAmount: 320000,
    requestedBy: 'Maha Project Manager',
    requesterId: 3,
    requestDate: '2024-02-25',
    status: 'Pending',
    priority: 'Medium',
    businessJustification: 'Market expansion requires mobile presence to capture 40% of mobile users.',
    expectedROI: '180%',
    paymentSchedule: 'Quarterly',
    documents: ['Business_Case.pdf'],
    approverComments: null,
    submissionDeadline: '2024-03-15'
  }
]

export const mockFinancialReports = [
  {
    id: 1,
    reportType: 'Monthly Budget Summary',
    period: 'March 2024',
    totalAllocated: 1230000,
    totalSpent: 537900,
    totalRemaining: 692100,
    utilizationRate: '43.7%',
    projectBreakdown: []
  }
]

export const mockTasks = [
  {
    id: 1,
    title: 'Database Schema Design',
    description: 'Design and implement comprehensive database schema',
    status: 'Completed',
    priority: 'High',
    projectId: 1,
    project: 'E-commerce Platform Development',
    assignee: 'Abhi Consultant',
    assigneeId: 5,
    dueDate: '2024-02-15',
    completionDate: '2024-02-12',
    progress: 100,
    estimatedHours: 32,
    actualHours: 28,
    budget: 4800,
    spent: 4200
  }
]

export const mockConsultantRecommendations = [
  {
    id: 1,
    projectId: 1,
    projectName: 'E-commerce Platform Development',
    consultant: 'Abhi Consultant',
    consultantId: 5,
    recommendationType: 'Technical',
    title: 'Performance Optimization Strategy',
    description: 'Implement caching mechanisms and database optimization.',
    priority: 'High',
    estimatedImpact: 'High',
    implementationCost: 25000,
    timeframe: '4 weeks',
    status: 'Under Review',
    dateSubmitted: '2024-03-01',
    documents: ['Performance_Analysis.pdf']
  }
]

export const internalConsultants = [
  {
    id: 'c1',
    userId: 5,
    name: 'Abhi Consultant',
    specialty: 'AI Strategy',
    rate: 200,
    availability: 'On Contract',
    projects: 4,
    avatar: 'AH',
    department: 'Advisory'
  }
];

export const mockLinkedInSearch = (query) => {
  if (!query || query.trim() === "") return [];
  return [];
};

let pendingConsultantApprovals = [];
export const getPendingApprovals = () => pendingConsultantApprovals;
export const addPendingApproval = (approval) => {
  pendingConsultantApprovals = [approval, ...pendingConsultantApprovals];
};
export const updateApprovalStatus = (approvalId, newStatus) => {
  pendingConsultantApprovals = pendingConsultantApprovals.map(item =>
    item.id === approvalId ? { ...item, status: newStatus } : item
  );
};
